import { useCallback, useEffect, useRef } from "react";

export function useEventCallback<T extends (...args: any[]) => any>(
  callback: T,
) {
  const callbackRef = useRef<T>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useCallback((...args: Parameters<T>) => {
    return callbackRef.current(...args);
  }, []);
}
